import { useState } from "react";
import {
  FiltroCheckBody,
  FiltroCheckContainer,
  FiltroCheckElementos,
  FiltroCheckFooter,
  FiltroCheckHeader,
} from "./localStyle";
import camelize from "global/utils/camelize";

const FiltroCheck = ({
  elementos,
  values,
  defaultValue,
  labelValue,
  onClick,
}) => {
  //#region  ----------- constants ---------------
  const seleccionarTodoInicial = values?.includes("Todos");

  const initializeSelectedElements = () => {
    const initialSelected = {};
    elementos.forEach((elemento) => {
      initialSelected[elemento[defaultValue]] = seleccionarTodoInicial;
    });
    return initialSelected;
  };

  const [seleccionarTodo, setSeleccionarTodo] = useState(
    seleccionarTodoInicial
  );
  const [elementosSeleccionados, setElementosSeleccionados] = useState(
    initializeSelectedElements()
  );
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const manejarSeleccionarTodo = () => {
    const nuevoEstado = !seleccionarTodo;
    setSeleccionarTodo(nuevoEstado);
    const nuevosElementosSeleccionados = {};
    elementos.forEach((elemento) => {
      nuevosElementosSeleccionados[elemento[defaultValue]] = nuevoEstado;
    });
    setElementosSeleccionados(nuevosElementosSeleccionados);
  };

  const createArray = (items) => {
    return Object.keys(items).filter((propiedad) => items[propiedad]);
  };

  const manejarCambioElemento = (nombre) => {
    const nuevosElementosSeleccionados = {
      ...elementosSeleccionados,
      [nombre]: !elementosSeleccionados[nombre],
    };
    setElementosSeleccionados(nuevosElementosSeleccionados);
    const todosSeleccionados = Object.values(
      nuevosElementosSeleccionados
    ).every((valor) => valor === true);
    setSeleccionarTodo(todosSeleccionados);
  };

  const capitalizeStrings = (strings) => {
    return strings.map((str) => {
      return str
        .toLowerCase()
        .replace(/(^\w|\s\w|\(\w)/g, (char) => char.toUpperCase());
    });
  };
  //#endregion --------- funciones ---------------

  return (
    <FiltroCheckContainer>
      <FiltroCheckHeader>
        <div className="FiltroCheckHeader-input">
          <input
            id="checkbox-todos"
            className="FiltroCheck-checkbox"
            type="checkbox"
            checked={seleccionarTodo}
            onChange={manejarSeleccionarTodo}
          />
          <label htmlFor="checkbox-todos">Todos los Centros</label>
        </div>
      </FiltroCheckHeader>
      <FiltroCheckBody>
        <FiltroCheckElementos>
          {elementos.map((elemento, index) => (
            <div className="FiltroCheckElemento" key={index}>
              <input
                className="FiltroCheck-checkbox"
                type="checkbox"
                id={`checkbox-${index}`}
                checked={elementosSeleccionados[elemento[defaultValue]]}
                onChange={() => manejarCambioElemento(elemento[defaultValue])}
              />
              <label htmlFor={`checkbox-${index}`}>
                <div className="FiltroCheckElemento-label">
                  <span className="FiltroCheckElemento-labelBlack">
                    {camelize(elemento[defaultValue])}
                  </span>
                  <span className="FiltroCheckElemento-labelBlue">
                    {elemento[labelValue]}
                  </span>
                </div>
              </label>
            </div>
          ))}
        </FiltroCheckElementos>
      </FiltroCheckBody>
      <FiltroCheckFooter>
        <div
          onClick={() =>
            onClick(
              seleccionarTodo
                ? ["Todos"]
                : capitalizeStrings(createArray(elementosSeleccionados))
            )
          }
          className="FiltroCheckBtn"
        >
          Avanzar
        </div>
      </FiltroCheckFooter>
    </FiltroCheckContainer>
  );
};

export default FiltroCheck;
